import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-10",
  name: "Mintmark",
  slug: "mintmark",
  title: "Mintmark — a Fable World: fintech storefront",
  description:
    "An original fintech storefront designed by Fable: card faces whose engravings flood with mint ink, struck in numbered runs."
};

export default meta;
